export const favoriteDownload = `query {
    favoriteDownload {
            name,
            content
        }
    }`;